import { Action } from '../index';
import { FiltersTypes } from './filter.action'
import { FilterState } from './filter.model'

export const initialState: FilterState = {
  online: true,
  physical: true,
  openModalFilters: false,
  timezone: '',
  openModalHelp: false,
};


const _filterReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case FiltersTypes.setFilters:
      return {...state, ...action.data};

    case FiltersTypes.setTimezoneFilter:
      return {...state, timezone: action.data};

    case FiltersTypes.toggleFilterOnline:
      return {...state, online: !state.online};

    case FiltersTypes.toggleFilterPhysical:
      return {...state,  physical: !state.physical};

    case FiltersTypes.toggleModalFilterMobile:
      return {...state,  openModalFilters: !state.openModalFilters};

    case FiltersTypes.toggleModalHelp:
      return {...state,  openModalHelp: !state.openModalHelp};

    default:
      return state;
  }
}

export function filterReducer(state: FilterState | undefined, action: Action) {
  return _filterReducer(state, action);
}


// WEBPACK FOOTER //
// ./src/app/store/filter/filter.reducer.ts